import React from 'react';
import PropTypes from 'prop-types';
import { useFormikContext } from 'formik';
import Grid from '@material-ui/core/Grid';

import { Card } from 'core/components/card';
import { Label } from 'core/components/label';
import { Tooltip } from 'core/components/tooltip';
import Field from 'core/components/form/form.v2';

import useStyles from './farm-uw-questions-card.styles';

const options = [
  {
    value: 'true',
    label: 'Yes'
  },
  {
    value: 'false',
    label: 'No'
  }
];

const FarmUWQuestionsCard = ({ questions, label, variant }) => {
  const classes = useStyles({ variant });
  const { values } = useFormikContext();

  return (
    <Grid container className={classes.sectionContainer}>
      <Label type="subtitle1" className={classes.sectionHeader}>
        {label}
      </Label>

      <Card className={classes.questionsCard}>
        {questions.map((question) => {
          const showDetailsWhen = question.showDetailsWhen || [true, 'true'];
          const answer = showDetailsWhen.includes(values?.[question.id]);
          return (
            <Grid key={question.id} container className={classes.questionRow}>
              <Grid className={classes.questionText}>
                <Label type="sectionSubtitle">{question.question}</Label>
                {question.tooltip && <Tooltip text={question.tooltip} placement="right" smallIcon />}
              </Grid>
              <Field
                id={question.id}
                name={question.id}
                options={options}
                type="radio"
                mode="light"
                optionsSideBySide
                containerClassName={classes.radioContainer}
                showError={false}
              />
              {answer && (
                <Field
                  id={`${question.id}Details`}
                  name={`${question.id}Details`}
                  type="textarea"
                  mode="light"
                  label={question.label || 'Please provide details about your answer to this question'}
                  multiline
                  rows={3}
                  className={classes.detailsField}
                />
              )}
            </Grid>
          );
        })}
      </Card>
    </Grid>
  );
};

FarmUWQuestionsCard.propTypes = {
  questions: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      question: PropTypes.string.isRequired,
      tooltip: PropTypes.string,
      label: PropTypes.string
    })
  ).isRequired,
  label: PropTypes.string.isRequired
};

export default FarmUWQuestionsCard;
